function z(x) {
  const t = [];
  let r = 0, l = 0, s;
  ((h) => {
    h.start = "start", h.right = "right", h.up = "up", h.left = "left", h.down = "down";
  })(s || (s = {}));
  let n = "start", e = x[l][0].clone(), f = x[l][0].clone();
  for (; !x[0][0].clone().equals(f) || r < 2; )
    n === "start" ? (e = x[l][0].clone(), f.x > e.x && (e.x = f.x), f.z < e.z && (t.pop(), t[t.length - 2].z < e.z ? t[t.length - 1].x = e.x : e.x = t[t.length - 1].x), n = "right") : n === "right" ? (e = x[l][1].clone(), f.x > e.x && (t[t.length - 1].z = t[t.length - 2].z, t[t.length - 1].x = e.x), n = "up") : n === "up" ? (e = x[l][2].clone(), n = "start", l < x.length - 1 ? l++ : n = "left") : n === "left" ? (e = x[l][3].clone(), (f.z < e.z || f.z > e.z) && (t[t.length - 1].z = e.z), n = "down") : n === "down" && (e = x[l][0].clone(), f.x < e.x && (e.x = f.x), n = "left", l > 0 && l--), r++, t.push(e), f = e.clone();
  return t;
}
export {
  z as traceOuterPoints
};
//# sourceMappingURL=index.js.map
